// extracted by mini-css-extract-plugin
export default {"AuthForm":"Authentication_AuthForm__xZ9B5","AuthField":"Authentication_AuthField__MaGTN"};